import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TaxRateShiftsFacade } from './+state';
import { TaxRateShiftsStateModule } from './+state/taxrate-shifts.state.module';
import { TaxRateShiftsService } from './services';

@NgModule({
  imports: [CommonModule, TaxRateShiftsStateModule],
})
export class DomainTaxrateShiftsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainTaxrateShiftsModule,
      providers: [TaxRateShiftsService, TaxRateShiftsFacade],
    };
  }
}
